import { HttpClient } from '@angular/common/http';
import { provideTransloco, Translation, TranslocoLoader, TranslocoModule } from '@jsverse/transloco';
import { Injectable, NgModule } from '@angular/core';
import { environment } from '../../environments/environment';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
	constructor(private http: HttpClient) {}

	getTranslation(lang: string) {
		return this.http.get<Translation>(`/assets/i18n/${lang}.json?v=${new Date().getTime()}`);
	}
}

@NgModule({
	imports: [],
	exports: [TranslocoModule],
	providers: [
		provideTransloco({
			config: {
				availableLangs: ['en', 'de', 'fr', 'es'],
				defaultLang: 'en',
				fallbackLang: 'en',
				reRenderOnLangChange: true,
				prodMode: environment.production,
			},
			loader: TranslocoHttpLoader,
		}),
		provideTranslocoLocale({
			langToLocaleMapping: {
				de: 'de-DE',
				en: 'en-US',
				fr: 'fr-FR',
				es: 'es-ES',
			},
		}),
	],
})
export class TranslocoRootModule {}
